import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const CodeBlock = () => {
  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* CODE BLOCKS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Code Blocks</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Basic Code Block</label>
            <pre className="p-3 bg-slate-950 rounded border border-slate-600 text-xs text-slate-300 overflow-x-auto font-mono">
{`function hello() {
  console.log("Hello World");
}`}
            </pre>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<pre className="p-3 bg-slate-950 rounded text-xs font-mono">
{code}
</pre>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">With Language Label</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs text-slate-500 font-mono">python</span>
                <button className="text-xs text-amber-400 hover:text-amber-300"> Copy</button>
              </div>
              <pre className="text-xs text-slate-300 font-mono overflow-x-auto">
{`def greet(name):
    print(f"Hello {name}")`}
              </pre>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-3 bg-slate-950 rounded">
  <div className="flex justify-between mb-2">
    <span className="text-xs">language</span>
    <button>Copy</button>
  </div>
  <pre className="text-xs font-mono">code</pre>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">HTML Highlight</label>
            <pre className="p-3 bg-slate-950 rounded border border-slate-600 text-xs text-slate-300 overflow-x-auto font-mono">
{`<div className="p-4 bg-blue">
  <h1>Title</h1>
</div>`}
            </pre>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<pre className="p-3 bg-slate-950 rounded font-mono">
HTML content here
</pre>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">JSON Block</label>
            <pre className="p-3 bg-slate-950 rounded border border-slate-600 text-xs text-slate-300 overflow-x-auto font-mono">
{`{
  "name": "John",
  "age": 30,
  "active": true
}`}
            </pre>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<pre className="p-3 bg-slate-950 rounded font-mono">
{JSON.stringify(data, null, 2)}
</pre>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Line Numbers</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <table className="w-full text-xs font-mono text-slate-300">
                <tbody>
                  <tr>
                    <td className="pr-4 text-slate-600 text-right">1</td>
                    <td>const x = 10;</td>
                  </tr>
                  <tr>
                    <td className="pr-4 text-slate-600 text-right">2</td>
                    <td>const y = 20;</td>
                  </tr>
                  <tr>
                    <td className="pr-4 text-slate-600 text-right">3</td>
                    <td>return x + y;</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<table className="text-xs font-mono">
  <tr>
    <td className="pr-4 text-right">1</td>
    <td>code</td>
  </tr>
</table>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Shell / CLI</label>
            <pre className="p-3 bg-slate-950 rounded border border-slate-600 text-xs text-slate-300 overflow-x-auto font-mono">
{`$ npm install package
$ npm run build
$ npm start`}
            </pre>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<pre className="p-3 bg-slate-950 rounded font-mono">
$ command
$ another command
</pre>`} />
          </div>
        </div>
      </div>

      {/* STYLED CODE BLOCKS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Styled Variants</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Inline Code</label>
            <p className="text-sm text-slate-300">
              Use <code className="px-1.5 py-0.5 bg-slate-950 rounded text-xs text-amber-400 font-mono">const</code> for constants
              and <code className="px-1.5 py-0.5 bg-slate-950 rounded text-xs text-amber-400 font-mono">let</code> for variables.
            </p>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<code className="px-1.5 py-0.5 bg-slate-950 rounded text-amber-400">
  code
</code>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Diff / Changes</label>
            <pre className="p-3 bg-slate-950 rounded border border-slate-600 text-xs font-mono">
              <div className="text-red-500">- const old = value;</div>
              <div className="text-green-500">+ const new = value;</div>
              <div className="text-slate-400">  return result;</div>
            </pre>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<pre>
  <div className="text-red-500">- old line</div>
  <div className="text-green-500">+ new line</div>
</pre>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CodeBlock;


